export const FILTER_ACCOUNTS_GRID_PREFIX = 'FILTER_ACCOUNTS_GRID_';

export const FILTER_ACCOUNTS_GRID_SORTING =
  FILTER_ACCOUNTS_GRID_PREFIX + 'SORTING';
export const filterAccountsGridSorting = (selection) => ({
  type: FILTER_ACCOUNTS_GRID_SORTING,
  selection
});

export const FILTER_ACCOUNTS_GRID_MANAGEMENT =
  FILTER_ACCOUNTS_GRID_PREFIX + 'MANAGEMENT';
export const filterAccountsGridManagement = (selection) => ({
  type: FILTER_ACCOUNTS_GRID_MANAGEMENT,
  selection
});

export const FILTER_ACCOUNTS_GRID_MOBILE_COLUMN =
  FILTER_ACCOUNTS_GRID_PREFIX + 'MOBILE_COLUMN';
export const filterAccountsGridMobileColumn = (selection) => ({
  type: FILTER_ACCOUNTS_GRID_MOBILE_COLUMN,
  selection
});

export const FILTER_ACCOUNTS_GRID_ACCOUNT_TYPE =
  FILTER_ACCOUNTS_GRID_PREFIX + 'ACCOUNT_TYPE';
export const filterAccountsGridAccountType = (selection) => ({
  type: FILTER_ACCOUNTS_GRID_ACCOUNT_TYPE,
  selection
});

export const FILTER_ACCOUNTS_GRID_PRINT_LAYOUT =
  FILTER_ACCOUNTS_GRID_PREFIX + 'PRINT_LAYOUT';
export const filterAccountsGridPrintLayout = (selection) => ({
  type: FILTER_ACCOUNTS_GRID_PRINT_LAYOUT,
  selection
});

export const RESET_ACCOUNTS_GRID_FILTERS = 'RESET_ACCOUNTS_GRID_FILTERS';
export const resetAccountsGridFilters = () => ({
  type: RESET_ACCOUNTS_GRID_FILTERS
});
